const tableColumns = [
    "id",
    "firstname",
    "lastname",
    "jobtitle",
    "email",
    "company",
    "businessindustry",
    "newsletter",
    "termsandconditions",
    "phone",
    "pdfname",
];

const tableColumnSchema = {
    id: {
        type: "hidden",
        title: "id",
    },
    firstname: {
        type: "text",
        title: "First Name",
    },
    lastname: {
        type: "text",
        title: "Last Name",
    },
    jobtitle: {
        type: "text",
        title: "Job Title",
    },
    email: {
        type: "text",
        title: "Email Address",
    },
    company: {
        type: "text",
        title: "Company",
    },
    businessindustry: {
        type: "text",
        title: "Business Industry",
    },
    newsletter: {
        type: "boolean",
        title: "News Letter",
    },
    termsandconditions: {
        type: "boolean",
        title: "Terms and Conditions",
    },
    phone: {
        type: "text",
        title: "Phone",
    },
    pdfname: {
        type: "pdfLink",
        title: "PDF",
    },
};

export const utility = {
    tableColumns,
    tableColumnSchema,
};
    
